"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64
}, props, {
  viewBox: "0 0 64 64"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.903 131.998c0-65.17 52.83-118 118-118s118 52.83 118 118-52.83 118-118 118-118-52.83-118-118"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 133.903,
  y1: 13.999,
  x2: 133.903,
  y2: 249.999,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad",
  id: "B"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1d93d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#38b0e3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 265.9h266.987V0H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 265.9h266.987V0H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 265.9h266.987V0H0z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.271187 0 0 -.271187 -4.312678 67.796339)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.903 131.998c0-65.17 52.83-118 118-118s118 52.83 118 118-52.83 118-118 118-118-52.83-118-118",
  fill: "url(#B)",
  clipPath: "url(#A)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#C)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.778 123.374l14-38.75S111.528 81 113.403 81s29.75 29 29.75 29l31 59.875-77.875-36.5z",
  fill: "#c8daea"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#D)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M114.34 113.436l-2.688-28.562s-1.125-8.75 7.625 0 17.125 15.5 17.125 15.5",
  fill: "#a9c6d8"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#E)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.03 121.99l-28.795 9.383s-3.437 1.395-2.333 4.562c.228.653.687 1.208 2.062 2.167 6.382 4.447 118.104 44.604 118.104 44.604s3.155 1.062 5.02.356c.852-.323 1.396-.688 1.854-2.02.167-.485.263-1.516.25-2.542-.01-.74-.1-1.425-.166-2.5-.68-10.98-21.04-92.918-21.04-92.918s-1.218-4.795-5.583-4.958c-1.592-.06-3.524.263-5.834 2.25-8.565 7.368-38.172 27.265-44.713 31.64-.37.246-.474.567-.537.88-.092.46.4 1.034.4 1.034s51.552 45.825 52.924 50.633c.106.373-.293.557-.834.396-3.424-1.26-62.78-38.74-69.33-42.88-.383-.242-1.457-.086-1.457-.086",
  fill: "#fff"
}))));
var _default = exports.default = SvgComponent;